import l10n from "diy/util/l10n";
import WebcomponentUpsell from "diy/app-upsell/webcomponentUpsell";

import Poller from "../Poller";
import Type from "../definitions/Type";
import Severity from "../definitions/Severity";
import {NotificationConfig} from "../definitions/Config";

export default {
    type: Type.WEB_COMPONENT_UPSELL,
    testId: "web-component-upsell",
    trackingId: "WebComponentUpsellFinishedNotification",

    severity: Severity.HIGH,

    bubbleOptions: {
        closable: false,
        autoHide: false
    },

    cardOptions: {
        hidden: true
    },

    onShow: () => {
        Poller.stop();
    },

    onFactory: (notificationConfig: NotificationConfig) => {
        let webComponentId = notificationConfig.payload.webComponentId;

        let translationKey: string = webComponentId + ".upsell";
        let description = l10n(translationKey + ".notification.description");
        let description2 = l10n(translationKey + ".notification.description2");
        let later = l10n(translationKey + ".later");
        let yes = l10n(translationKey + ".yes");

        notificationConfig.content = description + "<br />" + description2;
        notificationConfig.dismissAction = {
            testId: "later",
            label: later,
            onClick: () => {
                WebcomponentUpsell.setStatusToSuccessSeen(false, webComponentId);
                WebcomponentUpsell.trackLink('close', webComponentId);
            }
        };
        notificationConfig.mainAction = {
            testId: "yes",
            label: yes,
            onClick: () => {
                WebcomponentUpsell.setStatusToSuccessSeen(true, webComponentId);
                WebcomponentUpsell.trackLink('jumpToSiteAdmin', webComponentId);
            }
        };
        return notificationConfig;
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/WebComponentUpsell.ts
 **/